class AccidentPlanComponent extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector("cart-drawer");
    this.currentProductProperties = {};
  }

  connectedCallback() {
    this.initElements();
    this.initCallbackFunctions();
  }

  disconnectedCallback() {}

  initElements() {
    this.dialog = this.querySelector("dialog#accident-plan-component--dialog");

    this.addProtectionPlanBtn = this.querySelector(
      "#accident-plan-component--add-protection-plan"
    );

    this.headerCloseDialogBtn = this.querySelector(
      "header button.accident-plan-component--close-dialog"
    );

    this.footerCloseDialogBtn = this.querySelector(
      "#accident-plan-component--footer  button.accident-plan-component--close-dialog"
    );

    this.options = this.querySelector("#accident-plan-component--options");

    this.itemVariantId = this.querySelector("#item-variant-id");
  }

  initCallbackFunctions() {
    this.headerCloseDialogBtn.addEventListener("click", () => {
      this.dialog.close();
    });

    this.footerCloseDialogBtn.addEventListener("click", () => {
      this.dialog.close();
    });

    this.addProtectionPlanBtn.addEventListener("click", () => {
      this.addProtectionPlan();
    });

    document.addEventListener(
      "addAccidentPlanEvent",
      this.addAccidentPlanEventHandler.bind(this)
    );

    document.addEventListener(
      "changeAccidentPlanEvent",
      this.addAccidentPlanEventHandler.bind(this)
    );

    document.addEventListener(
      "removeAccidentPlanEvent",
      this.removeAccidentPlanEventHandler.bind(this)
    );
  }

  async addProtectionPlan(cartData) {
    if (!cartData) {
      cartData = this.buildProductData();
    }

    this.addProtectionPlanBtn.disabled = true;

    try {
      // Send request
      const request = await fetch(
        window.Shopify.routes.root + "cart/change.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cartData),
        }
      );

      // Await the request response
      const response = await request.json();

      // Render the cart drawer with the response
      this.renderCartDrawer(response);
    } catch (error) {
      // Print error in the console
      console.log(`❌ Engraving Error | ${error}`);
    } finally {
      this.addProtectionPlanBtn.disabled = false;
      this.dialog.close();
    }
  }

  addAccidentPlanEventHandler(event) {
    this.loadAccidentPlanOptions(
      event.detail.productAccidentPlan,
      event.detail.productVariantId
    );
    this.currentProductProperties = event.detail.productProperties;
    this.dialog.show();
    this.cart.close();
  }

  removeAccidentPlanEventHandler(event) {
    this.loadAccidentPlanOptions(
      event.detail.productAccidentPlan,
      event.detail.productVariantId
    );
    this.currentProductProperties = event.detail.productProperties;

    let clearedProductProperties = this.clearProductProperties();

    let cartData = {
      id: `${this.itemVariantId.value}`,
      properties: {
        ...clearedProductProperties,
      },
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };

    this.addProtectionPlan(cartData);
  }

  loadAccidentPlanOptions({ productPlan, accidentPlanName }, productVariantId) {
    let [twoYearsPlan, fiveYearsPlan] = productPlan.variants;
    this.querySelector("#accident-plan-two-years").value = twoYearsPlan.id;
    this.querySelector("#accident-plan-two-years").dataset.planName =
      accidentPlanName;
    this.querySelector("#accident-plan-two-years").dataset.planPrice =
      twoYearsPlan.price;
    this.querySelector(`label[for="accident-plan-two-years"]`).innerHTML = `
      <b>2 Years Plan</b>
      <span>$${twoYearsPlan.price}</span>
    `;

    this.querySelector("#accident-plan-five-years").value = fiveYearsPlan.id;
    this.querySelector(`label[for="accident-plan-five-years"]`).innerHTML = `
      <b>5 Years Plan</b>
      <span>$${fiveYearsPlan.price}</span>
    `;
    this.querySelector("#accident-plan-five-years").dataset.planName =
      accidentPlanName;
    this.querySelector("#accident-plan-five-years").dataset.planPrice =
      fiveYearsPlan.price;

    this.itemVariantId.value = productVariantId;
  }

  /**
   * Renders the cart drawer with the updated cart response.
   * @param {Object} response - The cart response object.
   * */
  renderCartDrawer(response) {
    const { sections } = response;

    const parsedResponse = {
      id: response.id,
      sections,
    };

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: "engraving-form",
      productVariantId: parsedResponse.id,
      cartData: parsedResponse,
    });

    this.cart.renderContents(parsedResponse);

    if (this.cart && this.cart.classList.contains("is-empty"))
      this.cart.classList.remove("is-empty");
  }

  buildProductData() {
    const checkedInput = this.options.querySelector(
      `input[type="radio"]:checked`
    );
    if (!checkedInput) return;

    let planId = checkedInput.value;
    let { planName, planPrice, planPeriod } = checkedInput.dataset;
    let clearedProductProperties = this.clearProductProperties();

    let cartData = {
      id: `${this.itemVariantId.value}`,
      properties: {
        ...clearedProductProperties,
        _protection_plan_variant_id: `gid://shopify/ProductVariant/${planId}`,
        _protection_plan_price: planPrice,
        "_Accident Plan": `${planName} | ${planPeriod}`,
      },
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };

    return cartData;
  }

  clearProductProperties() {
    let properties = this.currentProductProperties;
    delete properties["_Accident Plan"];
    delete properties["_protection_plan_variant_id"];
    delete properties["_protection_plan_price"];

    return !Object.keys(properties).length
      ? { _accident_plan_removed: true }
      : properties;
  }
}
customElements.define("accident-plan-component", AccidentPlanComponent);
